import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=e6292600"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6292600')) {
      api.createRecord('e6292600', component.options)
    } else {
      api.reload('e6292600', component.options)
    }
    module.hot.accept("./ScrollToTop.vue?vue&type=template&id=e6292600", function () {
      api.rerender('e6292600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/template/Resources/Private/Assets/Scripts/Components/ScrollToTop.vue"
export default component.exports